import {TMedia, TPosition, commonMixins} from './common';
import {TInputProps, formMixins} from './form';
import {layoutMixins} from './layout';
import {typographyMixins} from './typography';

export const mixins = {
  ...commonMixins,
  ...formMixins,
  ...layoutMixins,
  ...typographyMixins,
} as const;

export type {TMedia, TPosition, TInputProps};
